import {
  ENTITY_TYPE,
  checkPermission,
  genMenuType,
  isCheckDomain,
  isTradeDomain,
} from 'utils';

type MenuProps = {
  accountItem?: any;
  isCentralEntity?: boolean;
  permissions: any;
};

const genDefaultRedirect = ({ permissions = [] }: { permissions: any }) => {
  const links = [
    ...(checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportRevenue',
    })
      ? ['/report/revenue']
      : []),
    ...(checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportDebt',
    })
      ? ['/report/debt']
      : []),
    ...(checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportSale',
    })
      ? ['/report/sale']
      : []),
    ...(checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'statisticsProduct',
    })
      ? ['/statistics/product']
      : []),
    ...(checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'statisticsQuantity',
    })
      ? ['/production-plan/report-quantity']
      : []),
  ];

  return links.length > 0 ? links[0] : '';
};

export const getDataMenuSystem = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps) => {
  const isCheckUI = isCheckDomain();
  const isTradeUI = isTradeDomain();

  if (isCheckUI) {
    return checkMenu({ accountItem, isCentralEntity, permissions });
  }

  if (isTradeUI) {
    return tradeMenu({ accountItem, isCentralEntity, permissions });
  }

  return [
    ...(genMenuType({ permissions }) > 2
      ? fullRoleMenu({ accountItem, isCentralEntity, permissions })
      : basicRoleMenu({ accountItem, isCentralEntity, permissions })),
    ...defaultMenu({ accountItem, isCentralEntity, permissions }),
  ];
};

const checkMenu = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps): any[] => [
  {
    id: Date.now(),
    layer: 1,
    title: 'Tổng quan',
    key: 'ecomend-overview',
    menu: [
      {
        id: Date.now(),
        name: 'Trang chủ',
        link: '/',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_home_page',
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Nhật ký',
    key: 'ecomend-dairy',
    menu: [
      {
        id: Date.now(),
        name: 'Đối tượng',
        link: '/field-plant/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_field_plant',
      },
      {
        id: Date.now(),
        name: 'Tem truy xuất',
        link: '/stamp/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_stamp',
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Tài nguyên',
    key: 'ecomend-resouce',
    menu: [
      {
        id: Date.now(),
        name: 'Sản phẩm',
        link: '/product/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_product',
      },
      {
        id: Date.now(),
        name: 'Vùng sản xuất',
        link: '/area/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_area',
      },
      {
        id: Date.now(),
        name: 'Quy trình',
        link: '/process/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'ecomend_process',
      },
    ],
  },
  ...defaultMenu({ accountItem, isCentralEntity, permissions }),
];

const tradeMenu = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps): any[] => [
  {
    id: Date.now(),
    layer: 1,
    title: 'Tổng quan',
    key: 'trade-overview',
    menu: [
      {
        id: Date.now(),
        name: 'Trang chủ',
        link: '/',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'trade_home_page',
      },
      {
        id: Date.now(),
        name: 'Báo cáo',
        key: 'statistics',
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
        }),
        link: genDefaultRedirect({ permissions }),
        groupLink: [
          '/statistics/revenue',
          '/statistics/product',
          '/production-plan/report-quantity',
          '/report/revenue',
          '/report/debt',
        ],
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Báo cáo',
            menu: [
              {
                id: Date.now(),
                name: 'Báo cáo tài chính',
                link: '/report/revenue',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportRevenue',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo công nợ',
                link: '/report/debt',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportDebt',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo bán hàng',
                link: '/report/sale',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportSale',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo kho',
                link: '/statistics/product',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'statisticsProduct',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: 0,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Bán hàng',
    key: 'trade-sale',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Bán tại quầy',
        link: '/sale/',
        subMenu: [],
        quantity: 0,
        isExpand: true,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'pos',
        }),
      },
      {
        id: Date.now(),
        name: 'Đơn hàng',
        groupLink: [
          '/sale-order-closing',
          '/sale-order-closing/sale-order-draft',
          '/sale/#',
          '/sale/balance',
          '/sale/returns',
          '/sale/billing',
        ],
        link: '/sale-order-closing',
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Đơn hàng',
            menu: [
              {
                id: Date.now(),
                name: 'Bán tại quầy',
                link: '/sale/',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'pos',
                }),
              },
              {
                id: Date.now(),
                name: 'Đơn hàng',
                link: '/sale-order-closing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Chia hàng',
                link: '/sale/balance',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationSplitOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/sale/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Đổi trả hàng',
                link: '/sale/returns',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationReturn',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tiện ích',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'saleUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Danh sách giao hàng',
                link: '/shipping-list',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilDeliveryList',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công đơn hàng',
                link: '/assign-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilAssignList',
                }),
              },
              {
                id: Date.now(),
                name: 'Tổng hợp số lượng',
                link: '/sale/statistics-product',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
              {
                id: Date.now(),
                name: 'Liên hệ bán hàng',
                link: '/sale-contact',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Khách hàng',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'customer',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Khách hàng',
                link: '/customer',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomerUser',
                }),
              },
              {
                id: Date.now(),
                name: 'Đối tác',
                link: '/partner',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomer',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh cửa hàng',
                link: '/branch',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerBranch',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Khách hàng',
        link: '/customer',
        groupLink: [
          '/customer',
          '/customer/segment/list',
          '/partner',
          '/partner/overview',
          '/partner/segment/list',
          '/branch',
          '/branch/overview',
          '/branch/segment/list',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'customer',
        }),
        subMenu: [],
        filter: undefined,
        quantity: null,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Kho hàng',
    key: 'trade-warehouse',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Tồn kho',
        link: '/inventory-product/list',
        groupLink: [
          '/stock-adjustments',
          '/stock-adjustments/list',
          '/inventory-product/list',
          '/entity-category/list',
          '/entity-material/list',
          '/entity-material/entity-material-category/list',
        ],
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'warehouse',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Tồn kho',
            menu: [
              {
                id: Date.now(),
                name: 'Quản lý kho',
                link: '/inventory-product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseProduct',
                }),
              },
              {
                id: Date.now(),
                name: 'Vật tư',
                link: '/entity-material/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityMaterial,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
              {
                id: Date.now(),
                name: 'Kiểm kho',
                link: '/stock-adjustments/list',
                subMenu: [],
                filter: undefined,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Thu mua',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'purchase',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đặt hàng',
                link: '/purchase/order-chain-supplier',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding:
                  !isCentralEntity ||
                  !checkPermission({
                    permissions,
                    module: 'warehouse',
                    groupFeature: 'purchase',
                    feature: 'purchaseBuy',
                  }),
              },
              {
                id: Date.now(),
                name: 'Đơn nhập hàng',
                link: '/buying-chain-order',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công nhập hàng',
                link: '/assign-purchase-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseAssign',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhà cung cấp',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'supplier',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Nhà cung cấp',
                link: '/supplier',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierSupplier',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh sản xuất',
                link: '/warehouse',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierWarehouse',
                }),
              },
            ],
          },
        ],
        filter: undefined,
      },
      {
        id: Date.now(),
        name: 'Thu mua',
        link: '/buying-chain-order',
        groupLink: [
          '/buying-chain-order',
          '/buying-chain-order/purchase-order-draft',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'purchase',
        }),
        subMenu: [],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Nhà cung cấp',
        link: '/supplier',
        groupLink: [
          '/supplier',
          '/supplier/segment/list',
          '/warehouse',
          '/supplier/overview',
          '/warehouse/:id/crm',
          '/supplier/:id/crm',
          '/warehouse/segment/list',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'supplier',
        }),
        subMenu: [],
        filter: undefined,
        quantity: null,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Kế toán',
    key: 'trade-finance',
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Hóa đơn',
        link: '/debt/billing',
        groupLink: [
          '/debt/billing',
          '/sale/#',
          '/debt/receipts',
          '/debt/returns',
          '/debt/categories',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'bill',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Hóa đơn',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'bill',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/debt/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billProof',
                }),
              },
              {
                id: Date.now(),
                name: 'Thu nợ',
                link: '/debt/collection',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billDebt',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Sổ quỹ',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'cashBook',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Phiếu thu',
                link: '/debt/receipts',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Phiếu chi',
                link: '/debt/payment',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookPayment',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Sổ quỹ',
        link: '/debt/receipts',
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'cashBook',
        }),
        subMenu: [],
        quantity: 0,
      },
    ],
  },
  ...defaultMenu({ accountItem, isCentralEntity, permissions }),
];

const fullRoleMenu = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps) => [
  {
    id: Date.now(),
    layer: 1,
    title: 'Tổng quan',
    key: 'overview',
    menu: [
      {
        id: Date.now(),
        name: 'Trang chủ',
        link: '/',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'home_page',
      },
      {
        id: Date.now(),
        name: 'Báo cáo',
        key: 'statistics',
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
        }),
        link: genDefaultRedirect({ permissions }),
        groupLink: [
          '/statistics/revenue',
          '/statistics/product',
          '/production-plan/report-quantity',
          '/report/revenue',
          '/report/debt',
        ],
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Báo cáo',
            menu: [
              {
                id: Date.now(),
                name: 'Báo cáo tài chính',
                link: '/report/revenue',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportRevenue',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo công nợ',
                link: '/report/debt',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportDebt',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo bán hàng',
                link: '/report/sale',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'reportSale',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo kho',
                link: '/statistics/product',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'overview',
                  groupFeature: 'report',
                  feature: 'statisticsProduct',
                }),
              },
              {
                id: Date.now(),
                name: 'Báo cáo sản lượng',
                link: '/production-plan/report-quantity',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                isExpand: true,
                hidding:
                  !checkPermission({
                    permissions,
                    module: 'manufacturer',
                    groupFeature: 'manufacturerUtil',
                    feature: 'manufacturerUtilStatisticsQuantity',
                  }) &&
                  !checkPermission({
                    permissions,
                    module: 'overview',
                    groupFeature: 'report',
                    feature: 'statisticsQuantity',
                  }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: 0,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Bán hàng',
    key: 'seek_an_origin',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Bán tại quầy',
        link: '/sale/',
        subMenu: [],
        quantity: 0,
        isExpand: true,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'pos',
        }),
      },
      {
        id: Date.now(),
        name: 'Đơn hàng',
        groupLink: [
          '/sale-order-closing',
          '/sale-order-closing/sale-order-draft',
          '/sale/#',
          '/sale/balance',
          '/sale/returns',
          '/sale/billing',
        ],
        link: '/sale-order-closing',
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Đơn hàng',
            menu: [
              {
                id: Date.now(),
                name: 'Bán tại quầy',
                link: '/sale/',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'pos',
                }),
              },
              {
                id: Date.now(),
                name: 'Đơn hàng',
                link: '/sale-order-closing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Chia hàng',
                link: '/sale/balance',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationSplitOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/sale/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Đổi trả hàng',
                link: '/sale/returns',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationReturn',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tiện ích',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'saleUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Danh sách giao hàng',
                link: '/shipping-list',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilDeliveryList',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công đơn hàng',
                link: '/assign-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilAssignList',
                }),
              },
              {
                id: Date.now(),
                name: 'Tổng hợp số lượng',
                link: '/sale/statistics-product',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
              {
                id: Date.now(),
                name: 'Liên hệ bán hàng',
                link: '/sale-contact',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Khách hàng',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'customer',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Khách hàng',
                link: '/customer',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomerUser',
                }),
              },
              {
                id: Date.now(),
                name: 'Đối tác',
                link: '/partner',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomer',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh cửa hàng',
                link: '/branch',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerBranch',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Tiện ích',
        link: '/shipping-list',
        groupLink: [
          '/sale-contact',
          '/shipping-list',
          '/assign-task',
          '/sale/statistics-product',
        ],
        hidding: true,
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Đơn hàng',
            menu: [
              {
                id: Date.now(),
                name: 'Bán tại quầy',
                link: '/sale/',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'pos',
                }),
              },
              {
                id: Date.now(),
                name: 'Đơn hàng',
                link: '/sale-order-closing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Chia hàng',
                link: '/sale/balance',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationSplitOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/sale/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Đổi trả hàng',
                link: '/sale/returns',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationReturn',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tiện ích',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'saleUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Danh sách giao hàng',
                link: '/shipping-list',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilDeliveryList',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công đơn hàng',
                link: '/assign-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilAssignList',
                }),
              },
              {
                id: Date.now(),
                name: 'Tổng hợp số lượng',
                link: '/sale/statistics-product',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
              {
                id: Date.now(),
                name: 'Liên hệ bán hàng',
                link: '/sale-contact',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Khách hàng',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'customer',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Khách hàng',
                link: '/customer',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomerUser',
                }),
              },
              {
                id: Date.now(),
                name: 'Đối tác',
                link: '/partner',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomer',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh cửa hàng',
                link: '/branch',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerBranch',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Khách hàng',
        link: '/customer',
        groupLink: [
          '/customer',
          '/customer/segment/list',
          '/partner',
          '/partner/overview',
          '/partner/segment/list',
          '/branch',
          '/branch/overview',
          '/branch/segment/list',
        ],
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Đơn hàng',
            menu: [
              {
                id: Date.now(),
                name: 'Bán tại quầy',
                link: '/sale/',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'pos',
                }),
              },
              {
                id: Date.now(),
                name: 'Đơn hàng',
                link: '/sale-order-closing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Chia hàng',
                link: '/sale/balance',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationSplitOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/sale/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Đổi trả hàng',
                link: '/sale/returns',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'operation',
                  feature: 'operationReturn',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tiện ích',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'saleUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Danh sách giao hàng',
                link: '/shipping-list',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilDeliveryList',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công đơn hàng',
                link: '/assign-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilAssignList',
                }),
              },
              {
                id: Date.now(),
                name: 'Tổng hợp số lượng',
                link: '/sale/statistics-product',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
              {
                id: Date.now(),
                name: 'Liên hệ bán hàng',
                link: '/sale-contact',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'saleUtil',
                  feature: 'saleUtilTotalQuantity',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Khách hàng',
            hidding: !checkPermission({
              permissions,
              module: 'sale',
              groupFeature: 'customer',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Khách hàng',
                link: '/customer',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomerUser',
                }),
              },
              {
                id: Date.now(),
                name: 'Đối tác',
                link: '/partner',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerCustomer',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh cửa hàng',
                link: '/branch',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'sale',
                  groupFeature: 'customer',
                  feature: 'customerBranch',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Kho hàng',
    key: 'sale-manager',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Tồn kho',
        link: '/inventory-product/list',
        groupLink: [
          '/stock-adjustments',
          '/stock-adjustments/list',
          '/inventory-product/list',
          '/entity-category/list',
          '/entity-material/list',
          '/entity-material/entity-material-category/list',
        ],
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'warehouse',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Tồn kho',
            menu: [
              {
                id: Date.now(),
                name: 'Quản lý kho',
                link: '/inventory-product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseProduct',
                }),
              },
              {
                id: Date.now(),
                name: 'Vật tư',
                link: '/entity-material/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityMaterial,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
              {
                id: Date.now(),
                name: 'Kiểm kho',
                link: '/stock-adjustments/list',
                subMenu: [],
                filter: undefined,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Thu mua',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'purchase',
            }),
            groupLink: [
              '/buying-chain-order',
              '/buying-chain-order/purchase-order-draft',
            ],
            menu: [
              {
                id: Date.now(),
                name: 'Đặt hàng',
                link: '/purchase/order-chain-supplier',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding:
                  !isCentralEntity ||
                  !checkPermission({
                    permissions,
                    module: 'warehouse',
                    groupFeature: 'purchase',
                    feature: 'purchaseBuy',
                  }),
              },
              {
                id: Date.now(),
                name: 'Đơn nhập hàng',
                link: '/buying-chain-order',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công nhập hàng',
                link: '/assign-purchase-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseAssign',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhà cung cấp',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'supplier',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Nhà cung cấp',
                link: '/supplier',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierSupplier',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh sản xuất',
                link: '/warehouse',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierWarehouse',
                }),
              },
            ],
          },
        ],
        filter: undefined,
      },
      {
        id: Date.now(),
        name: 'Thu mua',
        link: '/buying-chain-order',
        groupLink: [
          '/buying-chain-order',
          '/buying-chain-order/purchase-order-draft',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'purchase',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Tồn kho',
            menu: [
              {
                id: Date.now(),
                name: 'Quản lý kho',
                link: '/inventory-product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseProduct',
                }),
              },
              {
                id: Date.now(),
                name: 'Vật tư',
                link: '/entity-material/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityMaterial,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
              {
                id: Date.now(),
                name: 'Kiểm kho',
                link: '/stock-adjustments/list',
                subMenu: [],
                filter: undefined,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Thu mua',
            groupLink: [
              '/buying-chain-order',
              '/buying-chain-order/purchase-order-draft',
            ],
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'purchase',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đặt hàng',
                link: '/purchase/order-chain-supplier',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding:
                  !isCentralEntity ||
                  !checkPermission({
                    permissions,
                    module: 'warehouse',
                    groupFeature: 'purchase',
                    feature: 'purchaseBuy',
                  }),
              },
              {
                id: Date.now(),
                name: 'Đơn nhập hàng',
                link: '/buying-chain-order',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công nhập hàng',
                link: '/assign-purchase-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseAssign',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhà cung cấp',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'supplier',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Nhà cung cấp',
                link: '/supplier',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierSupplier',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh sản xuất',
                link: '/warehouse',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierWarehouse',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Nhà cung cấp',
        link: '/supplier',
        groupLink: [
          '/supplier',
          '/supplier/segment/list',
          '/warehouse',
          '/supplier/overview',
          '/warehouse/:id/crm',
          '/supplier/:id/crm',
          '/warehouse/segment/list',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'supplier',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Tồn kho',
            menu: [
              {
                id: Date.now(),
                name: 'Quản lý kho',
                link: '/inventory-product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseProduct',
                }),
              },
              {
                id: Date.now(),
                name: 'Vật tư',
                link: '/entity-material/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityMaterial,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
              {
                id: Date.now(),
                name: 'Kiểm kho',
                link: '/stock-adjustments/list',
                subMenu: [],
                filter: undefined,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'warehouse',
                  feature: 'warehouseMaterial',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Thu mua',
            groupLink: [
              '/buying-chain-order',
              '/buying-chain-order/purchase-order-draft',
            ],
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'purchase',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đặt hàng',
                link: '/purchase/order-chain-supplier',
                subMenu: [],
                quantity: 0,
                isExpand: true,
                hidding:
                  !isCentralEntity ||
                  !checkPermission({
                    permissions,
                    module: 'warehouse',
                    groupFeature: 'purchase',
                    feature: 'purchaseBuy',
                  }),
              },
              {
                id: Date.now(),
                name: 'Đơn nhập hàng',
                link: '/buying-chain-order',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseOrder',
                }),
              },
              {
                id: Date.now(),
                name: 'Phân công nhập hàng',
                link: '/assign-purchase-task',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'purchase',
                  feature: 'purchaseAssign',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhà cung cấp',
            hidding: !checkPermission({
              permissions,
              module: 'warehouse',
              groupFeature: 'supplier',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Nhà cung cấp',
                link: '/supplier',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierSupplier',
                }),
              },
              {
                id: Date.now(),
                name: 'Chi nhánh sản xuất',
                link: '/warehouse',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'warehouse',
                  groupFeature: 'supplier',
                  feature: 'supplierWarehouse',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Kế toán',
    key: 'finance',
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Hóa đơn',
        link: '/debt/billing',
        groupLink: [
          '/debt/billing',
          '/sale/#',
          '/debt/receipts',
          '/debt/returns',
          '/debt/categories',
        ],
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'bill',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Hóa đơn',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'bill',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/debt/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billProof',
                }),
              },
              {
                id: Date.now(),
                name: 'Thu nợ',
                link: '/debt/collection',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billDebt',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Sổ quỹ',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'cashBook',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Phiếu thu',
                link: '/debt/receipts',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Phiếu chi',
                link: '/debt/payment',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookPayment',
                }),
              },
            ],
          },
        ],
        filter: undefined,
        quantity: null,
      },
      {
        id: Date.now(),
        name: 'Sổ quỹ',
        link: '/debt/receipts',
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Hóa đơn',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'bill',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Hóa đơn',
                link: '/debt/billing',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billProof',
                }),
              },
              {
                id: Date.now(),
                name: 'Thu nợ',
                link: '/debt/collection',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'bill',
                  feature: 'billDebt',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Sổ quỹ',
            hidding: !checkPermission({
              permissions,
              module: 'accounting',
              groupFeature: 'cashBook',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Phiếu thu',
                link: '/debt/receipts',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookBill',
                }),
              },
              {
                id: Date.now(),
                name: 'Phiếu chi',
                link: '/debt/payment',
                subMenu: [],
                quantity: 0,
                hidding: !checkPermission({
                  permissions,
                  module: 'accounting',
                  groupFeature: 'cashBook',
                  feature: 'cashBookPayment',
                }),
              },
            ],
          },
        ],
        quantity: 0,
      },
    ],
  },
  {
    id: Date.now(),
    layer: 1,
    title: 'Sản xuất',
    key: 'production-plan',
    hidding:
      accountItem.type == ENTITY_TYPE.COLLABORATOR ||
      !checkPermission({
        permissions,
        module: 'manufacturer',
      }),
    menu: [
      {
        id: Date.now(),
        name: 'Kế hoạch',
        link: '/production-plan/list',
        groupLink: ['/production-plan'],
        key: 'list_production_plan',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'manufacturerUtil',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Kế hoạch',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'manufacturerUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Kế hoạch sản xuất',
                link: '/production-plan/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProductionPlan,
                key: 'list_production_plan',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'manufacturerUtil',
                  feature: 'manufacturerUtilProductionPlan',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tài nguyên',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'resource',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Sản phẩm',
                link: '/product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProduction',
                }),
              },
              {
                id: Date.now(),
                name: 'Vùng sản xuất',
                link: '/area/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityArea,
                key: 'area',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceArea',
                }),
              },
              {
                id: Date.now(),
                name: 'Quy trình',
                link: '/process/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityProcess,
                key: 'process',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProcess',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhật ký',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'diary',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đối tượng',
                link: '/field-plant/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalFieldEntityProductObject,
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryProductObject',
                }),
              },
              {
                id: Date.now(),
                name: 'Tem truy xuất',
                link: '/stamp/list',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                key: 'stamp',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryStamp',
                }),
              },
            ],
          },
        ],
        filter: undefined,
      },
      {
        id: Date.now(),
        name: 'Tài nguyên',
        link: '/product/list',
        groupLink: [
          '/area',
          '/process',
          '/product',
          '/product/create',
          '/product/entity-category/list',
        ],
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'resource',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Kế hoạch',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'manufacturerUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Kế hoạch sản xuất',
                link: '/production-plan/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProductionPlan,
                key: 'list_production_plan',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'manufacturerUtil',
                  feature: 'manufacturerUtilProductionPlan',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tài nguyên',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'resource',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Sản phẩm',
                link: '/product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProduction',
                }),
              },
              {
                id: Date.now(),
                name: 'Vùng sản xuất',
                link: '/area/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityArea,
                key: 'area',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceArea',
                }),
              },
              {
                id: Date.now(),
                name: 'Quy trình',
                link: '/process/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityProcess,
                key: 'process',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProcess',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhật ký',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'diary',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đối tượng',
                link: '/field-plant/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalFieldEntityProductObject,
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryProductObject',
                }),
              },
              {
                id: Date.now(),
                name: 'Tem truy xuất',
                link: '/stamp/list',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                key: 'stamp',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryStamp',
                }),
              },
            ],
          },
        ],
      },
      {
        id: Date.now(),
        name: 'Nhật ký',
        link: '/field-plant/list',
        groupLink: [
          '/field-plant',
          '/farming-plant',
          '/production-plant',
          '/stamp',
        ],
        key: 'list_production_plan',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'diary',
        }),
        subMenu: [
          {
            id: Date.now(),
            layer: 2,
            title: 'Kế hoạch',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'manufacturerUtil',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Kế hoạch sản xuất',
                link: '/production-plan/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProductionPlan,
                key: 'list_production_plan',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'manufacturerUtil',
                  feature: 'manufacturerUtilProductionPlan',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Tài nguyên',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'resource',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Sản phẩm',
                link: '/product/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalProduct,
                key: 'list_product',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProduction',
                }),
              },
              {
                id: Date.now(),
                name: 'Vùng sản xuất',
                link: '/area/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityArea,
                key: 'area',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceArea',
                }),
              },
              {
                id: Date.now(),
                name: 'Quy trình',
                link: '/process/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalEntityProcess,
                key: 'process',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'resource',
                  feature: 'resourceProcess',
                }),
              },
            ],
          },
          {
            id: Date.now(),
            layer: 2,
            title: 'Nhật ký',
            hidding: !checkPermission({
              permissions,
              module: 'manufacturer',
              groupFeature: 'diary',
            }),
            menu: [
              {
                id: Date.now(),
                name: 'Đối tượng',
                link: '/field-plant/list',
                subMenu: [],
                filter: undefined,
                quantity: accountItem.totalFieldEntityProductObject,
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryProductObject',
                }),
              },
              {
                id: Date.now(),
                name: 'Tem truy xuất',
                link: '/stamp/list',
                subMenu: [],
                filter: undefined,
                quantity: 0,
                key: 'stamp',
                hidding: !checkPermission({
                  permissions,
                  module: 'manufacturer',
                  groupFeature: 'diary',
                  feature: 'diaryStamp',
                }),
              },
            ],
          },
        ],
        filter: undefined,
      },
    ],
  },
];

const basicRoleMenu = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps) => [
  {
    id: Date.now(),
    layer: 1,
    title: 'Tổng quan',
    key: 'overview',
    menu: [
      {
        id: Date.now(),
        name: 'Trang chủ',
        link: '/',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'home_page',
      },
      {
        id: Date.now(),
        name: 'Báo cáo tài chính',
        link: '/report/revenue',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
          feature: 'reportRevenue',
        }),
      },
      {
        id: Date.now(),
        name: 'Báo cáo công nợ',
        link: '/report/debt',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
          feature: 'reportDebt',
        }),
      },
      {
        id: Date.now(),
        name: 'Báo cáo bán hàng',
        link: '/report/sale',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
          feature: 'reportSale',
        }),
      },
      {
        id: Date.now(),
        name: 'Báo cáo kho',
        link: '/statistics/product',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'overview',
          groupFeature: 'report',
          feature: 'statisticsProduct',
        }),
      },
      {
        id: Date.now(),
        name: 'Báo cáo sản lượng',
        link: '/production-plan/report-quantity',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        isExpand: true,
        hidding:
          !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'manufacturerUtil',
            feature: 'manufacturerUtilStatisticsQuantity',
          }) &&
          !checkPermission({
            permissions,
            module: 'overview',
            groupFeature: 'report',
            feature: 'statisticsQuantity',
          }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Đơn hàng',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
    }),
    groupLink: [
      '/sale-order-closing',
      '/sale-order-closing/sale-order-draft',
      '/sale/#',
      '/sale/balance',
      '/sale/returns',
      '/sale/billing',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Bán tại quầy',
        link: '/sale/',
        subMenu: [],
        quantity: 0,
        isExpand: true,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'pos',
        }),
      },
      {
        id: Date.now(),
        name: 'Đơn hàng',
        link: '/sale-order-closing',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
          feature: 'operationOrder',
        }),
      },
      {
        id: Date.now(),
        name: 'Chia hàng',
        link: '/sale/balance',
        subMenu: [],
        quantity: 0,
        isExpand: true,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
          feature: 'operationSplitOrder',
        }),
      },
      {
        id: Date.now(),
        name: 'Hóa đơn',
        link: '/sale/billing',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
          feature: 'operationBill',
        }),
      },
      {
        id: Date.now(),
        name: 'Đổi trả hàng',
        link: '/sale/returns',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'operation',
          feature: 'operationReturn',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Tiện ích',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
    }),
    groupLink: ['/shipping-list', '/assign-task', '/sale/statistics-product'],
    menu: [
      {
        id: Date.now(),
        name: 'Danh sách giao hàng',
        link: '/shipping-list',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'saleUtil',
          feature: 'saleUtilDeliveryList',
        }),
      },
      {
        id: Date.now(),
        name: 'Phân công đơn hàng',
        link: '/assign-task',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'saleUtil',
          feature: 'saleUtilAssignList',
        }),
      },
      {
        id: Date.now(),
        name: 'Tổng hợp số lượng',
        link: '/sale/statistics-product',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'saleUtil',
          feature: 'saleUtilTotalQuantity',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Khách hàng',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
    }),
    groupLink: [
      '/customer',
      '/customer/list',
      '/partner',
      '/partner/overview',
      '/branch',
      '/branch/overview',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Khách hàng',
        link: '/customer',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'customer',
          feature: 'customerCustomerUser',
        }),
      },
      {
        id: Date.now(),
        name: 'Đối tác',
        link: '/partner',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'customer',
          feature: 'customerCustomer',
        }),
      },
      {
        id: Date.now(),
        name: 'Chi nhánh cửa hàng',
        link: '/branch',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'sale',
          groupFeature: 'customer',
          feature: 'customerBranch',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Tồn kho',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
    }),
    groupLink: [
      '/stock-adjustments',
      '/stock-adjustments/list',
      '/entity-material',
      '/inventory-product/list',
      '/entity-material/list',
      '/entity-material/entity-material-category/list',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Quản lý kho',
        link: '/inventory-product/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalProduct,
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'warehouse',
          feature: 'warehouseProduct',
        }),
      },
      {
        id: Date.now(),
        name: 'Vật tư',
        link: '/entity-material/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalEntityMaterial,
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'warehouse',
          feature: 'warehouseMaterial',
        }),
      },
      {
        id: Date.now(),
        name: 'Kiểm kho',
        link: '/stock-adjustments/list',
        subMenu: [],
        filter: undefined,
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'warehouse',
          feature: 'warehouseMaterial',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Thu mua',
    groupLink: [
      '/buying-chain-order',
      '/buying-chain-order/purchase-order-draft',
    ],
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Đặt hàng',
        link: '/purchase/order-chain-supplier',
        subMenu: [],
        quantity: 0,
        isExpand: true,
        hidding:
          !isCentralEntity ||
          !checkPermission({
            permissions,
            module: 'warehouse',
            groupFeature: 'purchase',
            feature: 'purchaseBuy',
          }),
      },
      {
        id: Date.now(),
        name: 'Đơn nhập hàng',
        link: '/buying-chain-order',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'purchase',
          feature: 'purchaseOrder',
        }),
      },
      {
        id: Date.now(),
        name: 'Phân công nhập hàng',
        link: '/assign-purchase-task',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'purchase',
          feature: 'purchaseAssign',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Nhà cung cấp',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Nhà cung cấp',
        link: '/supplier',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'supplier',
          feature: 'supplierSupplier',
        }),
      },
      {
        id: Date.now(),
        name: 'Chi nhánh sản xuất',
        link: '/warehouse',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'warehouse',
          groupFeature: 'supplier',
          feature: 'supplierWarehouse',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Hóa đơn',
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
    }),
    groupLink: [
      '/debt/billing',
      '/debt/receipts',
      '/debt/returns',
      '/debt/categories',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Hóa đơn',
        link: '/debt/billing',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'bill',
          feature: 'billProof',
        }),
      },
      {
        id: Date.now(),
        name: 'Thu nợ',
        link: '/debt/collection',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'bill',
          feature: 'billDebt',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Sổ quỹ',
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'cashBook',
    }),
    menu: [
      {
        id: Date.now(),
        name: 'Phiếu thu',
        link: '/debt/receipts',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'cashBook',
          feature: 'cashBookBill',
        }),
      },
      {
        id: Date.now(),
        name: 'Phiếu chi',
        link: '/debt/payment',
        subMenu: [],
        quantity: 0,
        hidding: !checkPermission({
          permissions,
          module: 'accounting',
          groupFeature: 'cashBook',
          feature: 'cashBookPayment',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Kế hoạch',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'manufacturerUtil',
    }),
    groupLink: ['/production-plan'],
    menu: [
      {
        id: Date.now(),
        name: 'Kế hoạch sản xuất',
        link: '/production-plan/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalProductionPlan,
        key: 'list_production_plan',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'manufacturerUtil',
          feature: 'manufacturerUtilProductionPlan',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Tài nguyên',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
    }),
    groupLink: [
      '/area',
      '/process',
      '/product',
      '/product/create',
      '/product/entity-category/list',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Sản phẩm',
        link: '/product/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalProduct,
        key: 'list_product',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'resource',
          feature: 'resourceProduction',
        }),
      },
      {
        id: Date.now(),
        name: 'Vùng sản xuất',
        link: '/area/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalEntityArea,
        key: 'area',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'resource',
          feature: 'resourceArea',
        }),
      },
      {
        id: Date.now(),
        name: 'Quy trình',
        link: '/process/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalEntityProcess,
        key: 'process',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'resource',
          feature: 'resourceProcess',
        }),
      },
    ],
  },
  {
    id: Date.now(),
    layer: 2,
    title: 'Nhật ký',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
    }),
    groupLink: [
      '/field-plant',
      '/farming-plant',
      '/production-plant',
      '/stamp',
    ],
    menu: [
      {
        id: Date.now(),
        name: 'Đối tượng',
        link: '/field-plant/list',
        subMenu: [],
        filter: undefined,
        quantity: accountItem.totalFieldEntityProductObject,
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'diary',
          feature: 'diaryProductObject',
        }),
      },
      {
        id: Date.now(),
        name: 'Tem truy xuất',
        link: '/stamp/list',
        subMenu: [],
        filter: undefined,
        quantity: 0,
        key: 'stamp',
        hidding: !checkPermission({
          permissions,
          module: 'manufacturer',
          groupFeature: 'diary',
          feature: 'diaryStamp',
        }),
      },
    ],
  },
];

const defaultMenu = ({
  accountItem,
  isCentralEntity = false,
  permissions = [],
}: MenuProps): any[] => {
  const isCheckUI = isCheckDomain();
  return [
    {
      id: Date.now(),
      layer: 1,
      title: 'Cấu hình',
      key: 'branding',
      hidding: true,
      menu: [
        {
          id: Date.now(),
          name: 'Thiết lập',
          link: '/settings',
          groupLink: ['/settings/business'],
          subMenu: [],
          filter: undefined,
          quantity: null,
        },

        {
          id: Date.now(),
          name: 'Lời mời liên kết',
          hidding: true,
          link: '/partner/request',
          subMenu: [
            {
              id: Date.now(),
              title: 'Lời mời liên kết',
              layer: 2,
              menu: [
                {
                  id: Date.now(),
                  name: 'Yêu cầu liên kết',
                  link: '/partner/request',
                  subMenu: [],
                  filter: undefined,
                  quantity: 0,
                },
                {
                  id: Date.now(),
                  name: 'Chờ phê duyệt',
                  link: '/partner/waiting',
                  subMenu: [],
                  filter: undefined,
                  quantity: 0,
                },
                {
                  id: Date.now(),
                  name: 'Chờ xác nhận',
                  link: '/partner/pending',
                  subMenu: [],
                  filter: undefined,
                  quantity: 0,
                },
              ],
            },
          ],
          filter: undefined,
          quantity: accountItem.totalPartner,
        },
        {
          id: Date.now(),
          name: 'Thông báo',
          hidding: true,
          link: '/notification/overview/list',
          subMenu: [
            {
              id: Date.now(),
              layer: 2,
              title: 'Thông báo',
              menu: [
                {
                  id: Date.now(),
                  name: 'Thông báo chung',
                  link: '/notification/overview/list',
                  hidding: isCheckUI,
                  subMenu: [],
                },
                {
                  id: Date.now(),
                  name: 'Thông báo liên kết',
                  link: '/notification/linked/list',
                  subMenu: [],
                },
                {
                  id: Date.now(),
                  name: 'Thông báo hệ thống',
                  link: '/notification/system/list',
                  subMenu: [],
                },
                {
                  id: Date.now(),
                  name: 'Thông báo đơn hàng',
                  link: '/notification/order/list',
                  subMenu: [],
                },
                {
                  id: Date.now(),
                  name: 'Yêu cầu mua hàng',
                  link: '/notification/request-order/list',
                  subMenu: [],
                },
              ],
            },
          ],
          filter: undefined,
        },
      ],
    },
  ];
};
